/**
 * 服务号消息模版
 */
import React from 'react';
import { Button, Row, Col, Icon, Tooltip } from 'antd';
import PageLayout from '../../ui/PageLayout';
import MenuEdit from './WechatMsgTemplateEdit';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import { global_data } from '../../ui/auth'

class WechatMsgTemplateIndex extends React.Component {

    columns = [{
        title: '模板名称',
        dataIndex: 'templateName',
        width: '15%',
    }, {
        title: '模板编码',
        dataIndex: 'templateCode',
        width: '20%',
    }, {
        title: '模板id',
        dataIndex: 'templateId',
        width: '20%',
    }, {
        title: '消息概要',
        dataIndex: 'first',
        width: '18%',
    }, {
        title: '消息备注',
        dataIndex: 'remark',
        width: '18%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '7%',
        format: {0:'正常',1 :'删除', 2:'停用'}
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("WX_MSG_TEMPLATE_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("WX_MSG_TEMPLATE_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("WX_MSG_TEMPLATE_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("WX_MSG_TEMPLATE_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, record.id)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
    };

    add = () => {
        this.setState({ editData: {} });
        this.showModal();
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };

    //修改
    update = (info, e) => {
        this.setState({ editData: info });
        this.showModal();
    }

    //删除
    delete = (info, e) => {
        messager.confirm("是否删除该模板？", () => {
            http.post({
                url: '/wx/msgTemplate/delete',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //启用
    enable = (info, e) => {
        messager.confirm("是否启用该模板？", () => {
            http.post({
                url: '/wx/msgTemplate/enable',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("启用成功！");
                }
            });
        });
    }

    //停用
    disable = (info, e) => {
        messager.confirm("是否停用该模板？", () => {
            http.post({
                url: '/wx/msgTemplate/disable',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("停用成功！");
                }
            });
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            {global_data.authCode.includes("WX_MSG_TEMPLATE_ADD")?
                            <Col span={24} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.add}>新增</Button>
                            </Col>
                            :""}
                        </Row>
                    )}
                    requestType="get"
                    rowKey="id" url="/wx/msgTemplate/query/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MenuEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                />
            </div>
        )
    }
}

export default WechatMsgTemplateIndex;